import { SvgIcon } from '@mui/material';

const VIEWBOX = '0 0 16 16';
const iconSx = { fontSize: 'inherit' } as const;

const RadioUncheckedIcon = () => (
  <SvgIcon viewBox={VIEWBOX} sx={iconSx}>
    <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
  </SvgIcon>
);

const RadioCheckedIcon = () => (
  <SvgIcon viewBox={VIEWBOX} sx={iconSx}>
    <circle cx="8" cy="8" r="8" fill="currentColor" />
    <circle cx="8" cy="8" r="3" style={{ fill: 'var(--form-indicator-color)' }} />
  </SvgIcon>
);

export const radioIcon = <RadioUncheckedIcon />;
export const radioCheckedIcon = <RadioCheckedIcon />;
